import Service, { type Registry as Services, service } from '@ember/service';
import { ICONS_BRANDS_MAP } from '@mylighthouse/prism-icons-brand';
import type { Ota } from 'frontend-utils/models';

export default class OtaService extends Service {
  @service declare store: Services['store'];

  otaPrettyNameLookup: Record<string, string> = {};

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  getAllOTAs() {
    return this.store.peekAll<Ota>('ota');
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  hasIcon(otaId: string) {
    return otaId in ICONS_BRANDS_MAP;
  }

  otaIdToPrettyName(otaId: string): string {
    const prettyName = this.otaPrettyNameLookup[otaId];
    if (prettyName) {
      return prettyName;
    }

    const ota = this.store.peekRecord<Ota>('ota', otaId);
    if (ota) {
      this.otaPrettyNameLookup[otaId] = ota.name;
      return ota.name;
    }

    return otaId.charAt(0).toUpperCase() + otaId.slice(1);
  }
}

declare module '@ember/service' {
  interface Registry {
    ota: OtaService;
  }
}
